const API_BASE_URL = process.env.VUE_APP_GLOBAL_URL;
const VUE_APP_FRONT_GLOBAL_URL = process.env.VUE_APP_FRONT_GLOBAL_URL;
const OAUTH2_API_BASE_UTL = process.env.VUE_APP_BACK_URL;
const OAUTH2_REDIRECT_URI = VUE_APP_FRONT_GLOBAL_URL;

export default Object.freeze({
    SESSION_STORAGE_TOKEN: 'ylw_token',
    SESSION_STORAGE_REDIRECT: 'ylw_redirect',

    ACCEPT_COOKIE_NAME: 'ylw_accept_cookie',
    TRIAL_WINDOW_EMAIL_COOKIE_NAME: 'ylw_trial_window',

    ACCESS_TOKEN: 'accessToken',
    GOOGLE_AUTH_URL: OAUTH2_API_BASE_UTL + '/oauth2/authorize/google?redirect_uri=' + OAUTH2_REDIRECT_URI,

    ROLE: {
        CLIENT: 'ROLE_CLIENT',
        ADMIN: 'ROLE_ADMIN'
    },

    APP_MAIN_PAGE: 'https://ylww.ru',
    APP_EMAIL: 'info@ylw.ru.com',

    dictionary: {
        custom: {
            email: {
                required: 'Введите адрес электронной почты',
                email: 'Введите адрес электронной почты'
            },
            password: {
                required: 'Введите пароль',
                regex: 'Пароль должен содержать от 4 до 16 символов. Можно использовать цифры и буквы латинского алфавита в верхнем или нижнем регистре'
            },
            passwordRepeat: {
                required: 'Введите пароль',
                confirmed: 'Значения в полях не совпадают',
            },
            emailRepeat: {
                required: 'Введите адрес электронной почты',
                confirmed: 'Значения в полях не совпадают',
            }
        }
    }

});

